







































































import Vue from 'vue'
import Component from 'vue-class-component'
import _get from 'lodash/get'

@Component
export default class Organization extends Vue {
  loading: boolean = false
  uploading: boolean = false
  modalVisible: boolean = false
  modalLoading: boolean = false
  modalTitle: string = 'Add Organization'
  columns = [
    {
      title: 'ID',
      dataIndex: 'id',
    },
    {
      title: 'Name',
      dataIndex: 'name',
    },
    {
      title: 'Person in Charge',
      dataIndex: 'pic',
    },
    {
      title: 'Action',
      dataIndex: 'operation',
      fixed: 'right',
      width: 160,
      scopedSlots: { customRender: 'action' },
    },
  ]
  rules = {
    name: [
      { required: true, message: 'Name must not be empty', trigger: 'blur' },
    ],
  }
  states = [
    'W.P. Kuala Lumpur',
    'W.P. Putrajaya',
    'W.P. Labuan',
    'Johor',
    'Kedah',
    'Kelatan',
    'Melaka',
    'Negeri Sembilan',
    'Pahang',
    'Perak',
    'Perlis',
    'Pulau Pinang',
    'Sabah',
    'Sarawak',
    'Terengganu'
  ]
  form = {} as any
  isEdit: boolean = false

  get organizations() {
    return this.$store.state.organizationStore.organizations 
  }

   get total() {
    return this.$store.state.organizationStore.total
  }

  get pagination() {
    return this.$store.state.organizationStore.pagination
  }

  get searchKey() {
    return this.$store.state.organizationStore.search
  }

  set searchKey(val) {
    this.$store.commit('updateOrganizationSearchKey', val)
  }

  mounted() {
    this.loading = true
    this.$store.dispatch('getOrganizations', {
      page: this.pagination.current,
      limit: this.pagination.pageSize
    }).then(() => {
      this.loading = false
      this.pagination.total = this.total
    })
    .catch(() => {
      this.loading = false
    })
  }

  updateOrganizations(pagination:any, filters:any, sorter:any) {
    this.loading = true
    this.$store.commit('updateOrganizationPagination', {current: pagination.current})
    this.$store.commit('updateOrganizationSorter', {field: sorter.field, order: sorter.order === 'ascend'? 'asc': 'desc'})
    this.$store.dispatch('getOrganizations').then(() => {
      this.loading = false
    })
  }

  search() {
    this.loading = true
    this.$store.commit('updateOrganizationPagination', {current: 1})
    this.$store.dispatch('getOrganizations').then(() => {
      this.loading = false
    })
  }

  showCreateOrganization() {
    this.modalVisible = true
    this.modalTitle = 'Create Organization'
    this.isEdit = false
    this.form = {}
  }

  showEditOrganization(organization: any) {
    this.form = { ...organization }
    this.modalTitle = 'Edit Organization'
    this.isEdit = true
    this.modalVisible = true
  }

  showDeletion(organization: any) {
    const h = this.$createElement
    const _this = this
    this.$confirm({
      title: 'Organization Delete',
      okText: 'Confirm',
      content: h('div', {}, [
        'Are you sure you want to delete ',
        h('strong', organization.name),
        '? All users attached to the organization will be deleted.'
      ]),
      onOk() {
        _this.$store.dispatch('deleteOrganization', organization.id)
      }
    })
  }

  saveOrganization() {
    this.modalLoading = true
    if (this.isEdit) {
      return this.$store.dispatch('updateOrganization', this.form).then(() => {
        this.modalLoading = false
        this.modalVisible = false
        this.form = {}
        this.$message.success("Organization Updated")
      })
      .catch(e => {
        this.modalLoading = false
        this.$message.error(JSON.stringify(_get(e, 'response.data.messages', 'Something went wrong')))
      })
    }
    else {
      return this.$store.dispatch('addOrganization', this.form).then(() => {
        this.modalLoading = false
        this.modalVisible = false
        this.form = {}
        this.$message.success("Organization Created")
      })
      .catch(e => {
        this.modalLoading = false
        this.$message.error(JSON.stringify(_get(e, 'response.data.messages', 'Something went wrong')))
      })
    }
  }

  cancelForm() {
    this.modalVisible = false
    this.modalLoading = false
    this.uploading = false
    this.form = {}
  }
}
